module.exports = __webpack_public_path__ + "img/fioletdown.d3071ab1.png";